import { useAppDispatch } from '../../reducers/store.ts'
import { useSelector } from 'react-redux'
import DataGrid from '../data-grid/DataGrid.tsx'
import { selectGroup } from '../../reducers/groups/groups.slice.ts'
import { useEffect } from 'react'
import { getUserGroups } from '../../reducers/groups/groups.thunk.ts'
import { policyGroupColumns } from './PolicyGroupColumns.tsx'
import { IconInfoCircle, IconUsersGroup } from '@tabler/icons-react'
import { Button } from '@radix-ui/themes'

interface IPolicyGroupsProps {
  checkedItems: Record<number, boolean>
  setCheckedItems: (checkedItems: Record<number, boolean>) => void
}

function PolicyGroups(props: IPolicyGroupsProps) {
  const { checkedItems, setCheckedItems } = props
  const di = useAppDispatch()
  const { userGroups } = useSelector(selectGroup)

  useEffect(() => {
    di(getUserGroups())
  }, [])

  const handleCheckboxChange = (id: number) => {
    if (checkedItems[id]) {
      setCheckedItems({
        ...checkedItems,
        [id]: false,
      })
    } else {
      setCheckedItems({
        ...checkedItems,
        [id]: true,
      })
    }
  }

  const hasAnyChecked = Object.keys(checkedItems || {}).length > 0

  return (
    <div className="flex flex-col px-2 max-w-[1200px] mx-auto">
      {!hasAnyChecked && (
        <div className="w-full px-4 py-3 bg-tableRowGrey rounded-md outline outline-1 outline-offset-[-1px] outline-mainBorder inline-flex justify-between items-center mb-2">
          <div className="inline-flex flex-col justify-start items-start gap-1">
            <div className="inline-flex justify-start items-center gap-2">
              <IconInfoCircle size={20} className="my-1.5" />
              <div className="justify-center text-mainText text-sm leading-4 font-medium">
                If no groups are selected this policy will apply to all members
              </div>
            </div>
          </div>
        </div>
      )}
      {userGroups && userGroups.length > 0 && (
        <DataGrid
          columns={policyGroupColumns(checkedItems, setCheckedItems, handleCheckboxChange)}
          data={userGroups}
          loading={userGroups === undefined}
          classNames="calc(100% - 264px)"
        />
      )}
      {userGroups && userGroups.length === 0 && (
        <div className="block items-center mt-20">
          <div className="flex items-center justify-center">
            <IconUsersGroup className="h-12 w-12" />
          </div>
          <p className="text-center font-bold mt-4">No groups yet</p>
          <p className="text-center text-sm flex mx-auto max-w-[300px]">
            This policy will automatically be applied to all members. You can assign groups at a later stage.
          </p>
          <Button
            className="h-[34px] flex text-mainText bg-white hover:bg-white active:active:bg-white border-mainBorder mx-auto cursor-pointer mt-4"
            onClick={() => (window.location.href = `${window.location.origin}/docs/iverify-portal-guide/Integrations/`)}
          >
            Read docs
          </Button>
        </div>
      )}
    </div>
  )
}

export default PolicyGroups
